module.exports = __webpack_public_path__ + "img/6.6f86a2f1.jpg";